import { render } from "./RegistroEspeciales.vue?vue&type=template&id=310dad9a&scoped=true"
import script from "./RegistroEspeciales.vue?vue&type=script&lang=js"
export * from "./RegistroEspeciales.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./RegistroEspeciales.vue?vue&type=style&index=1&id=310dad9a&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310dad9a"]])

export default __exports__